export const PASSWORD_RESET_CONFIRM = `mutation PasswordResetConfirm($input: PasswordResetConfirmMutationInput!) {
    passwordResetConfirm(input: $input) {
        success
    }
}`;
